




const posts = [];
const postsImageContext = require.context('./images/posts', false, /\.(jpg|jpeg|png)$/);
postsImageContext.keys().forEach((postImagePath, index) => {
    posts.push({
        src: postsImageContext(postImagePath),
        filter: "posts"
    });
});


const billboards = [];
const billboardsImageContext = require.context('./images/billboards', false, /\.(jpg|jpeg|png)$/);
billboardsImageContext.keys().forEach((billboardImagePath, index) => {
    billboards.push({
        src: billboardsImageContext(billboardImagePath),
        filter: "billboards"
    });
});

const businessBrandings = [];
const businessBrandingsImageContext = require.context('./images/businessBrandings', false, /\.(jpg|jpeg|png)$/);
businessBrandingsImageContext.keys().forEach((businessBrandingImagePath, index) => {
    businessBrandings.push({
        src: businessBrandingsImageContext(businessBrandingImagePath),
        filter: "businessBrandings"
    });
});

const carBrandings = [];
const carBrandingsImageContext = require.context('./images/carBrandings', false, /\.(jpg|jpeg|png)$/);
carBrandingsImageContext.keys().forEach((carBrandingImagePath, index) => {
    carBrandings.push({
        src: carBrandingsImageContext(carBrandingImagePath),
        filter: "carBrandings"
    });
});

const domStickers = [];
const domStickersImageContext = require.context('./images/domStickers', false, /\.(jpg|jpeg|png)$/);
domStickersImageContext.keys().forEach((domStickerImagePath, index) => {
    domStickers.push({
        src: domStickersImageContext(domStickerImagePath),
        filter: "domStickers"
    });
});

const exhibitions = [];
const exhibitionsImageContext = require.context('./images/exhibitions', false, /\.(jpg|jpeg|png)$/);
exhibitionsImageContext.keys().forEach((exhibitionImagePath, index) => {
    exhibitions.push({
        src: exhibitionsImageContext(exhibitionImagePath),
        filter: "exhibitions"
    });
});

const graphicDesigns = [];
const graphicDesignsImageContext = require.context('./images/graphicDesigns', false, /\.(jpg|jpeg|png)$/);
graphicDesignsImageContext.keys().forEach((graphicDesignImagePath, index) => {
    graphicDesigns.push({
        src: graphicDesignsImageContext(graphicDesignImagePath),
        filter: "graphicDesigns"
    });
});



const cards = [];
const cardsImageContext = require.context('./images/cards', false, /\.(jpg|jpeg|png)$/);
cardsImageContext.keys().forEach((cardsImagePath, index) => {
    cards.push({
        src: cardsImageContext(cardsImagePath),
        filter: "cards"
    });
});

const stickers = [];
const stickersImageContext = require.context('./images/stickers', false, /\.(jpg|jpeg|png)$/);
stickersImageContext.keys().forEach((stickersImagePath, index) => {
    stickers.push({
        src: stickersImageContext(stickersImagePath),
        filter: "stickers"
    });
});

const boxes = [];
const boxesImageContext = require.context('./images/boxes', false, /\.(jpg|jpeg|png)$/);
boxesImageContext.keys().forEach((boxesImagePath, index) => {
    boxes.push({
        src: boxesImageContext(boxesImagePath),
        filter: "boxes"
    });
});

const notes = [];
const notesImageContext = require.context('./images/notes', false, /\.(jpg|jpeg|png)$/);
notesImageContext.keys().forEach((notesImagePath, index) => {
    notes.push({
        src: notesImageContext(notesImagePath),
        filter: "notes"
    });
});

const special = [];
const specialImageContext = require.context('./images/special', false, /\.(jpg|jpeg|png)$/);
specialImageContext.keys().forEach((specialImagePath, index) => {
    special.push({
        src: specialImageContext(specialImagePath),
        filter: "special"
    });
});

const folders = [];
const foldersImageContext = require.context('./images/folders', false, /\.(jpg|jpeg|png)$/);
foldersImageContext.keys().forEach((foldersImagePath, index) => {
    folders.push({
        src: foldersImageContext(foldersImagePath),
        filter: "folders"
    });
});

const imagesData = [...billboards, ...posts, ...businessBrandings, ...carBrandings, ...domStickers, ...exhibitions, ...graphicDesigns, ...cards, ...stickers, ...boxes, ...notes, ...special, ...folders];

export { imagesData };
